export const environment = {
  production: true,
  apiEndpoint: window.location.origin + '/api',
  publicWebContactMeUrl: 'https://www.fortum.se',
  functionControlProductCode: 'DR12345',
  originUrl: window.location.origin
};
